var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"measure-legend"},[_vm._l((_vm.allMeasures.filter(m => m.role !== 'variance_measure')),function(measure,idx){return [_c('div',{key:`legend-${idx}`,staticClass:"legend-row",attrs:{"max-width":"128px"}},[_c('div',{staticClass:"legend-item",style:({
          'background-color': _vm.measureDatumColor(measure, null),
          'box-shadow': `0 0 3px ${_vm.measureDatumColor(measure, null)}`,
        })}),_vm._v(" "+_vm._s(measure.name)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }